import { RouterProvider } from 'react-router';
import { router } from './router';
import {
  Auth0AppProvider,
  Auth0SyncProvider,
  StoreProvider,
  ClientTenantSyncProvider,
  ClientPermissionsSyncProvider,
  AuthenticationController,
  FeatureFlagProvider,
} from './providers';
import { ScreenSizeOverlay } from './components/layout/ScreenSizeOverlay';

/**
 * Root Application Component
 *
 * Provider hierarchy:
 *  1. Auth0AppProvider              — Auth0 SDK context
 *  2. StoreProvider                 — Redux store
 *  3. Auth0SyncProvider             — Bridges Auth0 tokens → Redux
 *  4. ClientTenantSyncProvider      — Validates the token tenant via WebAPI
 *  5. AuthenticationController      — Owns login and post-login navigation
 *  6. FeatureFlagProvider           — Initializes LaunchDarkly
 *  7. ClientPermissionsSyncProvider — Initializes client permissions
 *  8. RouterProvider                — React Router
 *
 * i18n is initialized in main.tsx before rendering.
 */
export function App() {
  return (
    <Auth0AppProvider>
      <StoreProvider>
        <Auth0SyncProvider>
          <ClientTenantSyncProvider>
            <AuthenticationController>
              <FeatureFlagProvider>
                <ClientPermissionsSyncProvider>
                  <RouterProvider router={router} />
                  <ScreenSizeOverlay />
                </ClientPermissionsSyncProvider>
              </FeatureFlagProvider>
            </AuthenticationController>
          </ClientTenantSyncProvider>
        </Auth0SyncProvider>
      </StoreProvider>
    </Auth0AppProvider>
  );
}
